import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function ShippingReportForm() {
  const [startDate, setStartDate] = useState('2024-08-26');
  const [endDate, setEndDate] = useState('2024-09-02');
  const [shipper, setShipper] = useState('');
  const [shippingType, setShippingType] = useState('');
  const [format, setFormat] = useState('');


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'start_date':
        setStartDate(value);
        break;
      case 'end_date':
        setEndDate(value);
        break;
      case 'shipper':
        setShipper(value);
        break;
      case 'shipping_type':
        setShippingType(value);
        break;
      case 'format':
        setFormat(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here if needed
  };

  return (
    <div className=" mt-5">
      <h2 className="text-left mb-4" style={{ color: '#343a40' }}>Parameters</h2>
      <Form
        onSubmit={handleSubmit}
        className="p-4 border rounded shadow-sm"
        style={{
          borderTop: '5px solid #007bff',
          maxWidth: '700px',
          overflowY: 'auto',
        }}
      >
        <Form.Group as={Row} controlId="shipping-start-date">
          <Form.Label column md={4} className="font-weight-bold">
            Start Date <span className="text-danger">*</span>
          </Form.Label>
          <Col md={8}>
            <Form.Control
              type="date"
              name="start_date"
              value={startDate}
              onChange={handleInputChange}
              required
              className="border-secondary"
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="shipping-end-date">
          <Form.Label column md={4} className="font-weight-bold">
            End Date <span className="text-danger">*</span>
          </Form.Label>
          <Col md={8}>
            <Form.Control
              type="date"
              name="end_date"
              value={endDate}
              onChange={handleInputChange}
              required
              className="border-secondary"
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="shipper">
          <Form.Label column md={4} className="font-weight-bold">
            Shipper <span className="text-danger">*</span>
          </Form.Label>
          <Col md={8}>
            <Form.Control
              as="select"
              name="shipper"
              value={shipper}
              onChange={handleInputChange}
              className="border-secondary"
            >
              <option value="">All</option>
              <option value="1">Local Driver</option>
              <option value="3">Royal Mail</option>
              <option value="4">UPS COURIER</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="shipping_type">
          <Form.Label column md={4} className="font-weight-bold">
            Type <span className="text-danger">*</span>
          </Form.Label>
          <Col md={8}>
            <Form.Control
              as="select"
              name="shipping_type"
              value={shippingType}
              onChange={handleInputChange}
              className="border-secondary"
            >
              <option value="">Pickups and Deliveries</option>
              <option value="pickups">Just Pickups</option>
              <option value="deliveries">Just Deliveries</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="report_shipping_format">
          <Form.Label column md={4} className="font-weight-bold">
            Format <span className="text-danger">*</span>
          </Form.Label>
          <Col md={8}>
            <Form.Control
              as="select"
              name="format"
              value={format}
              onChange={handleInputChange}
              className="border-secondary"
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Col sm={{ span: 8, offset: 4 }}>
            <Link to="/Addshipping">
              <Button
                id="pay-per-task-submit"
                type="button"
                variant="primary"
                className="w-100 mt-2"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                Run
              </Button>
            </Link>
          </Col>
        </Form.Group>
      </Form>
      
    </div>
  );
}

export default ShippingReportForm;
